// @flow strict

import * as React from 'react';
import { Button } from '@ansarada/ace-react';
import cx from 'classnames';
import styles from './styles.scss';
import logo from '../../../../static/images/ansarada_logo.png';

type PropsType = {
  title: string,
  children: React.Node,
  actionButtons: React.ChildrenArray<React.Element<typeof Button> | void | false>,
  footer?: React.Node,
  bgMobile: string,
  bgDesktop: string,
  imageFirst?: boolean,
};

const OnBoardingLayout = ({
  title,
  children,
  actionButtons = [],
  footer,
  bgMobile,
  bgDesktop,
  imageFirst,
}: PropsType) => {
  return (
    <div className={cx(styles.page, imageFirst && styles.imageFirst)}>
      <div className={styles.header}>
        <a href="/">
          <img className={styles.logo} src={logo} alt="Ansarada" width="176" height="23" />
        </a>
      </div>
      <div className={styles.layoutContainer}>
        <div className={styles.stepContainer}>
          <div className={styles.main}>
            <h2 className={styles.title}>{title}</h2>
            <div
              className={cx(
                styles.content,
                bgDesktop || bgMobile ? styles.contentBg : styles.contentNoBg,
              )}
            >
              {children}
            </div>
            <div className={styles.actionButtonsGroup}>{actionButtons}</div>
            {footer && <div>{footer}</div>}
          </div>
        </div>
        {(bgDesktop || bgMobile) && (
          <div className={styles.imageWrapper}>
            {bgDesktop && <img src={bgDesktop} alt="" className={styles.bgDesktopImage} />}
            {bgMobile && <img src={bgMobile} alt="" className={styles.bgMobileImage} />}
          </div>
        )}
      </div>
    </div>
  );
};

export default OnBoardingLayout;
